import axios from "axios";
import BaseCamApi from "./BaseCamApi";
import CamBanner from "../CamBanner";

export default class ImLiveApi extends BaseCamApi {
    constructor(config) {
        super('ImLive', config);

        this.feedUrl = config.imLive.feedUrl;
        this.fallbackUrl = config.imLive.fallbackUrl;
    }

    /**
     * @param {string} gender
     * @returns {Promise<object[]>}
     */
    async loadRawBanners(gender) {
        const url = new URL(this.feedUrl);
        url.searchParams.set('gender', gender);

        try {
            const response = await axios.get(url.toString());
            return response.data || [];
        } catch (err) {
            console.error(err);
            return [];
        }
    }

    /**
     * @param {object} rawBanner
     * @returns {CamBanner}
     */
    makeCamBanner(rawBanner) {
        const kinks = rawBanner.PropList.l_kinkies.split(',');
        const randomKink = kinks.length ? kinks[Math.floor(Math.random() * kinks.length)] : null;

        return new CamBanner(
            rawBanner.NickName,
            rawBanner.NickName,
            rawBanner.PropList.age + (randomKink ? ', ' + randomKink : ''),
            rawBanner.MainImg + '&wi=400' + '&hi=-1',
            zone => {
                if (this.autoLoginData) {
                    const url = new URL(this.autoLoginData);
                    const goToPath = rawBanner.FreeSupported === "1" ? '/flash_sdk/freevideochatguest.aspx?nickname=' : '/chat.aspx?hostnick=';
                    url.searchParams.set('goto', goToPath + rawBanner.NickName);
                    return url.toString();
                }

                const url = new URL(this.fallbackUrl);
                url.searchParams.set('from', 'freevideo4');
                url.searchParams.set('nickname', rawBanner.NickName);
                return url.toString();
            },
        );
    }
};
